// extracted by mini-css-extract-plugin
module.exports = {"v1qkmgy2":"v1qkmgy2"};